module.exports = __webpack_public_path__ + "img/5.1a6c9b3c.webp";